import { jsx as a } from "react/jsx-runtime";
import { c as p } from "./clsx-OuTLNxxd.js";
const y = "_link_fvfdo_29", e = {
  link: y,
  "is-primary": "_is-primary_fvfdo_37",
  "is-secondary": "_is-secondary_fvfdo_43",
  "is-inverted": "_is-inverted_fvfdo_49",
  "is-underlined": "_is-underlined_fvfdo_55",
  "is-disabled": "_is-disabled_fvfdo_68",
  "dialog-overlay-show": "_dialog-overlay-show_fvfdo_1",
  "dialog-content-show": "_dialog-content-show_fvfdo_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_fvfdo_1"
}, u = {
  primary: "is-primary",
  secondary: "is-secondary",
  inverted: "is-inverted"
};
function N({
  color: c = "primary",
  children: s,
  href: d,
  target: l,
  disabled: i,
  Component: t,
  className: v,
  noUnderline: m = !1,
  ariaLabel: f,
  onClick: _,
  ...o
}) {
  const n = p(
    e.link,
    e[u[c]],
    i && e["is-disabled"],
    !m && e["is-underlined"],
    v
  ), r = /* @__PURE__ */ a("span", { className: n, ...o, children: s });
  return t ? i ? r : /* @__PURE__ */ a(t, { onClick: _, className: n, href: d, target: l, "aria-label": f, ...o, children: s }) : d ? i ? r : /* @__PURE__ */ a("a", { onClick: _, className: n, href: d, target: l, "aria-label": f, ...o, children: s }) : i ? r : /* @__PURE__ */ a("button", { onClick: _, className: n, ...o, children: s });
}
export {
  N as L,
  e as s
};
